import { NOT_FOUNDED } from '@shared/libs/errors-consts';
import { ErrorLayout } from '@shared/layouts/ErrorLayout';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRouteEvents } from '@shared/constants/router';

export const NotFoundPage: FC = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(getRouteEvents());
  };

  return <ErrorLayout error={NOT_FOUNDED} showBasicButton={true} navigateTo={handleNavigate} />;
};
